import axios, { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';

class ProviderApi {
  baseURL: string;
  private readonly axios: AxiosInstance;

  constructor(baseURL: string) {
    this.baseURL = baseURL;
    this.axios = axios.create({
      timeout: 10000,
      baseURL,
    });

    /* Handling our server responses, when errors, get verbose ones */
    this.axios.interceptors.response.use(
      (response: any) => response,
      (error: any) => {
        return Promise.reject(error.response);
      },
    );

    /**
     * Include API KEY in all requests
     */
    this.axios.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        const newConfig: AxiosRequestConfig = {
          ...config,
          headers: {
            ...config.headers,
            'X-API-KEY': new URL(window.location.href).searchParams.get('providerKey')
          },
        };
        return newConfig;
      },
      (error: any) => Promise.reject(error),
    );
  }
  /**
   * Function to leverage inner instance of axios to make call with interceptors based on configuration
   * @param path path to call
   * @param params axios request params
   * @returns axios promise
   */
  public custom = <T = any>(
    path: string,
    params?: Omit<AxiosRequestConfig, 'baseURL' | 'url'>,
  ): AxiosPromise<T> => {
    return this.axios({
      ...params,
      url: path,
      method: params?.method || 'GET',
    });
  };
}

const providerApi = new ProviderApi(
  process.env.REACT_APP_PROVIDER_API_URL as string,
);

export default providerApi;
